module.exports = __webpack_public_path__ + "static/media/elo.b5caf724.svg";